var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.468 17.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435",
    transform: "translate(7939.98 -3940.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_",
    transform: "translate(-7939.98 3941.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_907_",
    d: "M97.568,48.839H86.994A1.293,1.293,0,0,1,85.7,47.544V32.794A1.293,1.293,0,0,1,86.994,31.5H97.568a1.293,1.293,0,0,1,1.294,1.294v14.75A1.293,1.293,0,0,1,97.568,48.839Z",
    transform: "translate(-85.7 -31.5)",
    fill: "#047b10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_906_",
    d: "M98.8,59.66V45.282a.98.98,0,0,1,.982-.982h10.171a.98.98,0,0,1,.982.982V59.66a.98.98,0,0,1-.982.981H99.782A.985.985,0,0,1,98.8,59.66Z",
    transform: "translate(-98.288 -43.799)",
    fill: "#039c12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    d: "M198.716,30.366V26.471L193.3,21.2h-4Z",
    transform: "translate(-8125.229 3919.695)",
    fill: "#0c6815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_904_",
    d: "M189.3,21.2v.4h.415Z",
    transform: "translate(-8125.229 3919.695)",
    fill: "#0c4612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_903_",
    d: "M422.3,248v.3h.3Z",
    transform: "translate(-8349.118 3701.764)",
    fill: "#0c4612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M-2.287-1.816l.6-1.027h.57l-.859,1.41L-1.1,0h-.576l-.611-1.043L-2.9,0h-.574l.881-1.434-.861-1.41h.57ZM-.24-.395H1.051V0H-.734V-2.844H-.24ZM2.916-.732a.343.343,0,0,0-.132-.289,1.586,1.586,0,0,0-.476-.205,2.3,2.3,0,0,1-.547-.23.73.73,0,0,1-.389-.637.693.693,0,0,1,.28-.566,1.134,1.134,0,0,1,.728-.223,1.229,1.229,0,0,1,.529.109.869.869,0,0,1,.365.312.8.8,0,0,1,.133.448H2.916a.446.446,0,0,0-.14-.349.576.576,0,0,0-.4-.126.6.6,0,0,0-.376.1.345.345,0,0,0-.134.289.312.312,0,0,0,.145.261,1.665,1.665,0,0,0,.477.2,2.192,2.192,0,0,1,.533.225.848.848,0,0,1,.295.289.753.753,0,0,1,.094.382.677.677,0,0,1-.272.565A1.182,1.182,0,0,1,2.4.039a1.389,1.389,0,0,1-.567-.114.953.953,0,0,1-.4-.315.786.786,0,0,1-.144-.469h.494a.46.46,0,0,0,.16.375A.7.7,0,0,0,2.4-.352a.609.609,0,0,0,.388-.1A.337.337,0,0,0,2.916-.732Z",
    transform: "translate(-7933.399 3955)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.b6f19c32d375849c97fd480a66cbce6b.svg";
export { ForwardRef as ReactComponent };